// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"22773a20","186":"73fbe0d3","232":"2af38b49","753":"e5183259","940":"51547197"}[chunkId] + ".chunk.js";
};